(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.querySelector('.js-cart-drawer');
    var backdrop = document.querySelector('.js-cart-backdrop');
    if (!drawer || !backdrop) return;

    var body = drawer.querySelector('.js-cart-body');
    var foot = drawer.querySelector('.js-cart-foot');
    var subtotalEls = () => document.querySelectorAll('.js-cart-subtotal');
    var countLabelEls = () => document.querySelectorAll('.js-cart-count-label');
    var countBadgeEls = () => document.querySelectorAll('.js-cart-count');

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
    }

    function escapeHtml(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : s;
      return d.innerHTML;
    }

    function renderCart(cart) {
      countLabelEls().forEach((el) => { el.textContent = '(' + cart.item_count + ')'; });
      countBadgeEls().forEach((el) => { el.textContent = cart.item_count; });

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="' + drawer.dataset.allProductsUrl + '" class="btn btn-primary js-cart-close">Shop workbooks</a></div>';
        foot.hidden = true;
        return;
      }

      foot.hidden = false;
      subtotalEls().forEach((el) => { el.textContent = money(cart.total_price); });

      var html = cart.items.map(function (item, index) {
        var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + escapeHtml(item.product_title) + '">' : '';
        return (
          '<div class="cart-line" data-line="' + (index + 1) + '">' +
            img +
            '<div class="cart-line__info">' +
              '<p class="cart-line__title">' + escapeHtml(item.product_title) + '</p>' +
              '<p class="cart-line__price">' + money(item.price) + '</p>' +
              '<div class="cart-line__row">' +
                '<span class="cart-qty">' +
                  '<button type="button" class="js-cart-qty-down" aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" class="js-cart-qty-up" aria-label="Increase quantity">+</button>' +
                '</span>' +
                '<button type="button" class="cart-line__remove js-cart-remove">Remove</button>' +
              '</div>' +
            '</div>' +
            '<span class="cart-line__linetotal">' + money(item.final_line_price) + '</span>' +
          '</div>'
        );
      }).join('');
      body.innerHTML = html;
    }

    function showError(message) {
      var existing = body.querySelector('.cart-drawer__error');
      if (existing) existing.remove();
      var el = document.createElement('div');
      el.className = 'cart-drawer__error';
      el.textContent = message;
      body.prepend(el);
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    }

    function openDrawer() {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.classList.add('show');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove('show');
      document.body.style.overflow = '';
    }

    function changeLine(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then((r) => r.json())
        .then((cart) => renderCart(cart))
        .catch(() => showError("Couldn't update your cart. Please try again."));
    }

    body.addEventListener('click', function (e) {
      var lineEl = e.target.closest('.cart-line');
      if (!lineEl) return;
      var line = parseInt(lineEl.dataset.line, 10);
      var qtyEl = lineEl.querySelector('.cart-qty span');
      var qty = parseInt(qtyEl.textContent, 10);

      if (e.target.closest('.js-cart-qty-up')) {
        changeLine(line, qty + 1);
      } else if (e.target.closest('.js-cart-qty-down')) {
        changeLine(line, Math.max(0, qty - 1));
      } else if (e.target.closest('.js-cart-remove')) {
        changeLine(line, 0);
      }
    });

    backdrop.addEventListener('click', closeDrawer);
    document.querySelectorAll('.js-cart-close').forEach((btn) => btn.addEventListener('click', closeDrawer));
    document.querySelectorAll('.js-cart-icon').forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });
    window.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form.matches && form.matches('form[action*="/cart/add"]'))) return;
      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      var originalLabel = submitBtn ? submitBtn.textContent : null;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message || 'Something went wrong.');
          return fetchCart();
        })
        .then((cart) => {
          renderCart(cart);
          openDrawer();
        })
        .catch((err) => {
          fetchCart().then((cart) => {
            renderCart(cart);
            showError(err.message || "Couldn't add that to your cart.");
          });
          openDrawer();
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
